export const setAppBackgroundColor = (backgroundColor: string) => {
  document.documentElement.style.setProperty('--app-background-color', backgroundColor);
};
